import { createContext, Dispatch, ReactNode, useMemo, useReducer } from "react";
import streamingSlice, { initialStreamingState, StreamingStateProps } from "./streamingSlice";
import { UnknownAction } from "@reduxjs/toolkit";

interface StreamingContextProps {
  state: StreamingStateProps;
  dispatch: Dispatch<UnknownAction>;
}

export const StreamingContext = createContext<StreamingContextProps | undefined>(undefined);

interface StreamingContextProviderProps {
  children: ReactNode;
}

const StreamingContextProvider = ({ children }: StreamingContextProviderProps): JSX.Element => {
  const [state, dispatch] = useReducer(streamingSlice.reducer, initialStreamingState);

  const values = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch]
  );

  return <StreamingContext.Provider value={values}>{children}</StreamingContext.Provider>;
};

export default StreamingContextProvider;
